<template>
  <section v-if="editItem" id="BARRING_FACTORING_HISTORY_SHOW_EXCEPTIONS" class="offset-top-2 offset-bottom-6">
    <div class="container-fixed">
      <div class="row">
        <div class="col-l-10 col-s-12">
          <h3 class="h1">{{
            isProfileTypeCategories && $te('barring.contentTypeCode_' + editItem.name) ? $t('barring.contentTypeCode_' + editItem.name) : editItem.name
          }}</h3>
        </div>
        <div v-if="editItem.hasImage" class="col-l-2 col-s-12">
          <div class="logo_container pull-right offset-right-1">
            <img :src="getImageLocation" alt="" aria-hidden="true" class="logo" />
          </div>
        </div>
      </div>
      <br />
      <p
        v-if="isProfileTypeCategories"
        v-html="
          exceptionType !== 'voice-partner-exceptions' ? $t('barring.editCategoryExceptionsInfotext') : $t('barring.editCategoryExceptionsInfotextVoicePartner')
        "
      ></p>
      <p v-else v-html="$t('barring.editExceptionsInfotext')"></p>
    </div>
    <VSelection :items="items" :type="exceptionType" hide-filter-type read-only />

    <div class="container-fixed">
      <div class="row offset-top-2">
        <div class="col-l-8 col-s-12 offset-bottom-1">
          <p class="offset-left-1 offset-right-2" style="margin-top: -12px" v-html="$t('barring.saveExceptionsInfotext')"></p>
        </div>
        <div class="col-l-4 col-s-12">
          <div class="pull-right offset-right-1 button-bar">
            <VButton class="btn-default" :to="{ name: BARRING_FACTORING_HISTORY_SHOW }" label="barring.backToHistory" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import VButton from '@/components/Button';
import { BARRING_FACTORING_HISTORY, BARRING_FACTORING_HISTORY_SHOW } from '@route-types';
import TitleMixin from '@/mixins/title';
import VSelection from '@/components/Barring/PartnerSelection';

export default {
  name: 'BarringFactoringHistoryShowExceptions',

  components: {
    VButton,
    VSelection,
  },

  mixins: [TitleMixin],

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      BARRING_FACTORING_HISTORY_SHOW,
      editItem: null,
      items: [],
    };
  },

  computed: {
    ...mapState('barring', ['editItems', 'isProfileTypeCategories']),

    getImageLocation() {
      return `delegates/barring/content/${this.editItem.type === 'category' ? 'categories' : 'businesspartner'}/${this.editItem.partnerId}`;
    },

    exceptionType() {
      if (this.isProfileTypeCategories) {
        if (this.editItem.partnerId === 'VoicePartners') {
          return 'voice-partner-exceptions';
        }
        return 'content-partner-exceptions';
      }
      return 'shortCode';
    },
  },

  created() {
    this.editItem = this.editItems.find(item => item.id === this.id);
    if (this.editItem) {
      this.items = JSON.parse(JSON.stringify(this.editItem.items));
      if (!this.editItem.hasExceptions) {
        this.items.forEach(item => {
          item.isBarred = this.editItem.isBarred;
        });
      }
    } else {
      this.$router.push({ name: BARRING_FACTORING_HISTORY });
    }
  },
};
</script>

<style scoped>
.logo_container {
  height: 60px;
}
.logo {
  max-height: 60px;
}
</style>
